import { useMemo } from 'react';

import { TAdBannerPlaceParameters } from '../../AdBannerMicrofrontendContainer';

/**
 * Константы места баннера вторички над выдачей.
 * Должны совпадать с легаси-размещением Adfox (SellersAdfoxBannerContainer).
 */
const PLACE = 'above_offers';
const P_PARAMS: TAdBannerPlaceParameters['pParams'] = { p1: 'domzh', p2: 'hyhj' };
const SIZES: TAdBannerPlaceParameters['sizes'] = { width: '100%', height: 174 };

/**
 * Параметры места баннера вторички над выдачей (desktop).
 */
export function useSellersParameters(): TAdBannerPlaceParameters {
  return useMemo(
    () => ({
      place: PLACE,
      pParams: P_PARAMS,
      sizes: SIZES,
      position: null,
      galleryPosition: null,
      isSp: true,
      tgbNativedescGeneralDesign: null,
      carousel: null,
      deviceType: 'desktop',
    }),
    [],
  );
}
